/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationCommunicationMethod } from './ClaimReservationCommunicationMethod';
import {
    ClaimReservationCommunicationMethodFromJSON,
    ClaimReservationCommunicationMethodFromJSONTyped,
    ClaimReservationCommunicationMethodToJSON,
} from './ClaimReservationCommunicationMethod';

/**
 * 
 * @export
 * @interface ClaimReservationResponseDetails
 */
export interface ClaimReservationResponseDetails {
    /**
     * Timestamp of when the reservation was marked as a no-show by an admin
     * @type {Date}
     * @memberof ClaimReservationResponseDetails
     */
    noShowAt?: Date | null;
    /**
     * Timestamp of when the reservation was marked as checked in by an admin
     * @type {Date}
     * @memberof ClaimReservationResponseDetails
     */
    checkedInAt?: Date | null;
    /**
     * Optional field to capture if the reservation was most recently edited by a claims agent, and who that agent was
     * @type {string}
     * @memberof ClaimReservationResponseDetails
     */
    editedByAgentName?: string | null;
    /**
     * Optional field to capture if the reservation was created internally by a claims agent on behalf of a player, and who that agent was
     * @type {string}
     * @memberof ClaimReservationResponseDetails
     */
    createdByAgentName?: string | null;
    /**
     * Optional free form notes text about a reservation
     * @type {string}
     * @memberof ClaimReservationResponseDetails
     */
    notes: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimReservationResponseDetails
     */
    numberOfTickets: number;
    /**
     * 
     * @type {ClaimReservationCommunicationMethod}
     * @memberof ClaimReservationResponseDetails
     */
    communicationPreference: ClaimReservationCommunicationMethod;
    /**
     * Phone for the reservation, e.g. "123-456-7890"
     * Nullable for reservations made directly in the back office
     * @type {string}
     * @memberof ClaimReservationResponseDetails
     */
    phone?: string | null;
    /**
     * Email for the reservation, e.g. "john.doe@example.com"
     * Nullable for reservations made directly in the back office
     * @type {string}
     * @memberof ClaimReservationResponseDetails
     */
    email?: string | null;
    /**
     * Name for the reservation, e.g. "John Doe"
     * @type {string}
     * @memberof ClaimReservationResponseDetails
     */
    name: string;
    /**
     * If this reservation was rebooked under a new ID, this will contain the ID of the new reservation
     * @type {string}
     * @memberof ClaimReservationResponseDetails
     */
    rebookedAs?: string | null;
    /**
     * Whether this reservation is cancelled
     * @type {boolean}
     * @memberof ClaimReservationResponseDetails
     */
    isCancelled: boolean;
}



/**
 * Check if a given object implements the ClaimReservationResponseDetails interface.
 */
export function instanceOfClaimReservationResponseDetails(value: object): value is ClaimReservationResponseDetails {
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('numberOfTickets' in value) || value['numberOfTickets'] === undefined) return false;
    if (!('communicationPreference' in value) || value['communicationPreference'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isCancelled' in value) || value['isCancelled'] === undefined) return false;
    return true;
}

export function ClaimReservationResponseDetailsFromJSON(json: any): ClaimReservationResponseDetails {
    return ClaimReservationResponseDetailsFromJSONTyped(json, false);
}

export function ClaimReservationResponseDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimReservationResponseDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'noShowAt': json['noShowAt'] == null ? undefined : (new Date(json['noShowAt'])),
        'checkedInAt': json['checkedInAt'] == null ? undefined : (new Date(json['checkedInAt'])),
        'editedByAgentName': json['editedByAgentName'] == null ? undefined : json['editedByAgentName'],
        'createdByAgentName': json['createdByAgentName'] == null ? undefined : json['createdByAgentName'],
        'notes': json['notes'],
        'numberOfTickets': json['numberOfTickets'],
        'communicationPreference': ClaimReservationCommunicationMethodFromJSON(json['communicationPreference']),
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'],
        'rebookedAs': json['rebookedAs'] == null ? undefined : json['rebookedAs'],
        'isCancelled': json['isCancelled'],
    };
}

export function ClaimReservationResponseDetailsToJSON(value?: ClaimReservationResponseDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'noShowAt': value['noShowAt'] == null ? undefined : ((value['noShowAt'] as any).toISOString()),
        'checkedInAt': value['checkedInAt'] == null ? undefined : ((value['checkedInAt'] as any).toISOString()),
        'editedByAgentName': value['editedByAgentName'],
        'createdByAgentName': value['createdByAgentName'],
        'notes': value['notes'],
        'numberOfTickets': value['numberOfTickets'],
        'communicationPreference': ClaimReservationCommunicationMethodToJSON(value['communicationPreference']),
        'phone': value['phone'],
        'email': value['email'],
        'name': value['name'],
        'rebookedAs': value['rebookedAs'],
        'isCancelled': value['isCancelled'],
    };
}

